import { Component, OnInit } from '@angular/core';
import { ModalBase } from 'src/app/model/modal-base';
import { SupportService } from 'src/app/services/support.service';

@Component({
    selector: 'app-order-empty-modal',
    templateUrl: './order-empty-modal.component.html'
})
export class OrderEmptyModalComponent extends ModalBase implements OnInit
{
    public openingHours: string;

    private readonly supportService: SupportService;

    public constructor(supportService: SupportService)
    {
        super();
        this.supportService = supportService;
    }
    ngOnInit(): void {
        this.supportService.getOpeningHours().subscribe(
            openingHours => {
                const monday = openingHours.Monday;
                this.openingHours = `${monday.Opens} - ${monday.Closes}`;
            }
        )
    }
}
